import styled from 'styled-components';
import ScreenUtils from '../../../../shared/utils/screen';

const DescriptionMiddleInfoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: ${ScreenUtils.widthRatio * 58}px;
  margin-top: ${ScreenUtils.widthRatio * 12}px;
`;

export default DescriptionMiddleInfoContainer;
